export enum InstanceType {
  Prd = 'prd',
  Dev = 'dev',
  Local = 'local',
}

export function getInstanceType(): InstanceType {
  if (window.location.hostname === 'portal.performanceprosupply.com') {
    return InstanceType.Prd
  } else if (
    window.location.hostname === 'portal-dev.performanceprosupply.com'
  ) {
    return InstanceType.Dev
  } else {
    return InstanceType.Local
  }
}

// this gets called in non-hook contexts, which is why we didn't drop it
// directly in the hook
export function getQueryParms<T>(): T {
  return Object.fromEntries(new URLSearchParams(window.location.search)) as T
}

export function useQueryParams<T>(): T {
  return getQueryParms<T>()
}

export function round(value: number, decimals: number) {
  return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals)
}

export function calculateCCFee(invoices: Invoice[]) {
  const total = invoices.reduce((acc, i) => acc + i.ccFee, 0)
  return round(total, 2)
}

export function debounce<
  T extends (this: unknown, ...args: unknown[]) => unknown,
>(func: T, wait: number) {
  let timeout: ReturnType<typeof window.setTimeout> | undefined

  return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
    if (timeout !== undefined) window.clearTimeout(timeout)

    timeout = window.setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}
